import { FlowCreateNotableObjectConfigSchema, FlowNotableObject } from 'flow-schema';

import { type api } from 'common';

import { CreateNotableObjectFormFields } from './FormFields';
import { CreateNotableObjectDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const createNotableObjectConfig: BlockConfigProps<
  api.FlowDefinition.CreateNotableObjectBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'CreateNotableObject',
  defaultConfig: {
    notableObject: FlowNotableObject.Patient,
    payload: '',
  },
  configFields: {
    schema: FlowCreateNotableObjectConfigSchema,
    FormFields: CreateNotableObjectFormFields,
  },
  documentationMarkdown: CreateNotableObjectDocumentationMarkdown,
};
